import css from 'styled-jsx/css';

const styles = css.global`.ctn-home-24 {
  box-sizing: border-box;

  padding-right: 16px;
  padding-left: 16px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

@media (min-width: 600px) {
  .ctn-home-24 {
    max-width: 570px;
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 800px) {
  .ctn-home-24 {
    max-width: 100%;
    padding-right: 45px;
    padding-left: 45px;
  }
}

@media (min-width: 1280px) {
  .ctn-home-24 {
    max-width: 1208px;
  }
}

amp-script {
  opacity: 1;
}
`;

export default styles;